import Api from "utils/api";

export const fetchNotifications = async ({ pageParam }: any) => {
  return Api.get(`/notification/notification/user-notifications/`, {
    params: pageParam,
  }).then((res) => res.data);
};
export const fetchNotificationStat = async () => {
  return Api.get(`/notification/notification/stat/`).then((res) => res.data);
};

export const setReadAll = async () => {
  return Api.get(`/notification/notification/read-all`).then((res) => res.data);
};

export const readOneNotification = async (id: any) => {
  return Api.get(`/notification/notification/${id}/read`).then((res) => res.data);
};
